import React, { useState } from "react";
import styled from "styled-components";
import range from "ramda/src/range";
import append from "ramda/src/append";
import pathOr from "ramda/src/pathOr";
import inc from "ramda/src/inc";
import PeopleIcon from "@atlaskit/icon/glyph/people";
import CrossCircleIcon from "@atlaskit/icon/glyph/cross-circle";

import { Grid } from "../../UI/Grid";
import { Table } from "../../UI/Table";
import { TableCell } from "../../UI/TableCell";
import { TableHead } from "../../UI/TableHead";
import { TableRow } from "../../UI/TableRow";
import { UserNameLink } from "../UserNameLink";
import { ModalProvider } from "../../contexts/ModalContext";
import { Button } from "../../UI/Button";
import { EnhancedTableBody } from "../EnhancedTableBody";
import { PageTablePagination } from "../PageTablePagination";
import { HelpTooltip } from "../HelpTooltip";
import { Box } from "../../UI/Box";
import { COLOR_WELL_READ } from "../../constants/styles";
import useAuth from "../../routes/login/AuthContext";

const getRooms = pathOr([], ["rooms"]);

const LeftSwipesIcon = styled("img")`
  width: 16px;
  height: 16px;
`;

export const RoomSelectorsTable = ({
  results,
  selectedGroup,
  setGroup,
  maxRoomates,
  loading,
  isSelectedDisabled,
  reloadResults,
}) => {
  const [groupHasPlaceholder] = useState(false);
  const { isSuperAdminRead } = useAuth();

  const getPlaceHolderStatusFromRoom = (accum, current) =>
    accum || current.placeholder;

  const getCompatibilityValue = React.useCallback(
    (room) => {
      const anyPlaceHolderUser = room.roomOccupants.reduce(
        getPlaceHolderStatusFromRoom,
        false
      );

      if (anyPlaceHolderUser || groupHasPlaceholder) {
        return "N/A";
      }
      return room.compatibility + "%";
    },
    [groupHasPlaceholder]
  );

  const getSkippedSwipes = React.useCallback((swipes)=> {
    const skippedSwipes = swipes.filter(s => s.direction === "Skipped");
    return !!skippedSwipes.length;
  }, [results]);

  const handleGroupSelect = (room) => () => setGroup(append(room));
  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
          <TableCell>Available Groups for matching</TableCell>
            {selectedGroup.length > 0 && <TableCell align="right">Compatibility</TableCell>}
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <EnhancedTableBody
          isLoading={loading}
          colSpan={inc(range(1, maxRoomates).length)}
        >
          {getRooms(results).map((room, idx) => (
            <TableRow key={idx}>
              <TableCell>
              <Grid container>
              {room.roomOccupants.map((occupant, id, arr) => (
                <Grid item key={occupant.uid}>
                  <Grid container key={occupant.uid}>
                      <Grid item></Grid>
                        <ModalProvider>
                          <UserNameLink
                            openNewTab
                            id={occupant.uid}
                            name={occupant.name}
                          />
                          
                        </ModalProvider>
                        {occupant && !!occupant.priorRoommates.length && (
                          <Grid item>
                          <HelpTooltip
                            withIcon={false}
                            title="Prior Roommates"
                            text="These users were roommates on RoomSync in the past."
                          >
                            <PeopleIcon
                              size="small"
                              primaryColor={COLOR_WELL_READ}
                            />
                          </HelpTooltip>
                          </Grid>
                      )}
                      {occupant && !!occupant.priorRejects.length && (
                          <Grid item>
                          <HelpTooltip
                            withIcon={false}
                            title="Rejected Request"
                            text="There was a roommate request that was rejected between these two users."
                          >
                            <CrossCircleIcon
                              size="small"
                              primaryColor={COLOR_WELL_READ}
                            />
                          </HelpTooltip>
                          </Grid>
                      )}
                       {occupant && getSkippedSwipes(occupant.swipes) && (
                          <Grid item>
                          <HelpTooltip
                            withIcon={false}
                            title="Skipped User"
                            text="This user was swiped to the left, resulting in them being skipped."
                          >
                            <LeftSwipesIcon src="/static/images/icons/left_swipe.svg" />
                          </HelpTooltip>
                          </Grid>
                      )}
                        <>{id+1 < arr.length? "," : "" } &nbsp;</>

                  </Grid>
                </Grid>
              ))}
              </Grid>
              </TableCell>
              {selectedGroup.length > 0 && (
                <TableCell align="right">
                  <Box sx={{ fontWeight: 'bold' }}>
                    {getCompatibilityValue(room)}
                  </Box>
                </TableCell>
              )}
              <TableCell align="right">
                <Button
                  appearance="primary"
                  isLoading={false}
                  onClick={handleGroupSelect(room)}
                  isDisabled={isSuperAdminRead() || isSelectedDisabled}
                >
                  Select
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </EnhancedTableBody>
      </Table>
      <PageTablePagination />
    </>
  );
};
